// vendor-id (lowercase) → query-string fragment to append for evidence
export const EVIDENCE_BY_VENDOR = {
    robotstxt: "robotstxt.search=allow",
    fodid: "id.usage=non-marketing",
};

// Builds the query string suffix (including leading "?" or empty string)
// to append to the cloud JS script URL, based on which vendors are
// present in the selectedProperties list.
export function buildEvidenceQueryString(selectedProperties) {
    const vendors = new Set();
    for (const prop of selectedProperties) {
        const vendor = prop.split('.')[0].toLowerCase();
        if (EVIDENCE_BY_VENDOR[vendor]) {
            vendors.add(vendor);
        }
    }
    if (vendors.size === 0) return '';
    const parts = [];
    vendors.forEach(v => parts.push(EVIDENCE_BY_VENDOR[v]));
    return `?${parts.join('&')}`;
}
